// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__9WR8X","modal":"Modal_modal__q9m8z","header":"Modal_header__YviYA","close":"Modal_close__hDtmA","body":"Modal_body__b4cH-"};